import styled from 'styled-components';

export const PageContainer = styled.div`
  min-height: calc(100vh - 120px);
  padding: 20px; /* respeita navbar fixa do StoreTemplate */
  display: flex;
  align-items: flex-start;
  justify-content: center;

  /* Fundo com glow verde (#92b21f) + amarelo (#ffdf5a) sutil */
  background:
    radial-gradient(1200px 1000px at 12% -10%, rgba(146, 178, 31, 0.22), transparent 60%),
    radial-gradient(900px 520px at 88% -20%, rgba(255, 223, 90, 0.16), transparent 55%),
    linear-gradient(180deg, rgba(255, 255, 255, 0.02), rgba(255, 255, 255, 0) 40%),
    #0b0b0b;
`;

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const TitleIcon = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 12px;
  display: grid;
  place-items: center;
  background: linear-gradient(135deg, #ffdf5a, #ffd43b);
  color: #111;
`;

export const Actions = styled.div`
  margin-top: 8px;
  display: flex;
  gap: 12px;
  justify-content: flex-end;
`;
